import { Link } from "@tanstack/react-router";

import { useTerminology } from "../lib/terminology.js";

/** The 404 body; also stands in for a page whose feature the tenant has switched off. */
export function NotFound() {
  const { box } = useTerminology();
  return (
    <div className="py-16 text-center">
      <h1 className="text-xl font-semibold">Page not found</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        <Link to="/boxes" className="underline">
          Back to the {box.plural}
        </Link>
      </p>
    </div>
  );
}
